import React from "react";
import { ErrorMessageProps } from "./ErrorMessage.types";
import "./ErrorMessage.scss";

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  errorMessage,
  errorId,
}) => {
  return (
    <div
      aria-describedby={errorId}
      aria-live="assertive"
      role="alert"
      data-testid="errorMessage"
      className="mp-atoms-errorMessage--main"
    >
      {errorMessage}
    </div>
  );
};

export default ErrorMessage;
